import { apiPost } from '../../lib/api'
import { withAuth } from '../auth/token'

export interface CalculateCommissionRequest {
  loadTotal: number
  accessorials: number
  commissionPercentage: number
}

export interface CommissionBreakdown {
  loadTotal: number
  accessorials: number
  billableTotal: number
  commissionPercentage: number
  commission: number
  netToCarrier: number
  currency: string
}

export function calculateCommission(
  request: CalculateCommissionRequest,
): Promise<CommissionBreakdown> {
  // Commission math is financial data: the API wants a Dispatcher or Admin token.
  return apiPost<CommissionBreakdown>('/api/commissions/calculate', request, {
    headers: withAuth(),
  })
}
